(function () {
  var config = window.theme && window.theme.settings || {};
  var gwpActive = config.gwpActive;
  var GWP_VARIANT_ID = config.gwpVariantId;
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var processing = false;
  var dismissed = false;
  var hadGwpItem = false;

  function findGwpItem(items) {
    return items.find(function (item) {
      return item.properties && item.properties._gwp === 'true';
    });
  }

  function dispatchUpdate(response) {
    document.dispatchEvent(
      new CustomEvent('shapes:cart:update', {
        bubbles: true,
        detail: { response: response },
      })
    );
  }

  function removeGift(key, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        dispatchUpdate(data);
        processing = false;
        if (callback) callback();
      })
      .catch(function (err) {
        console.error('[GWP] remove error', err);
        processing = false;
      });
  }

  function addGift() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GWP_VARIANT_ID, quantity: 1, properties: { _gwp: 'true' } }],
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          console.error('[GWP] add rejected:', data.description || data.message);
          processing = false;
          return;
        }
        dispatchUpdate(data);
        processing = false;
      })
      .catch(function (err) {
        console.error('[GWP] add error', err);
        processing = false;
      });
  }

  function resetGiftQuantity(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 1,
        sections: SECTIONS,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        dispatchUpdate(data);
        processing = false;
      })
      .catch(function (err) {
        console.error('[GWP] reset qty error', err);
        processing = false;
      });
  }

  function syncGift() {
    if (processing) return;
    processing = true;

    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gwpItem = findGwpItem(cart.items);
        var nonGwpItems = cart.items.filter(function (item) {
          return !(item.properties && item.properties._gwp === 'true');
        });

        if (!gwpActive || !GWP_VARIANT_ID) {
          if (gwpItem) {
            hadGwpItem = false;
            return removeGift(gwpItem.key);
          }
          processing = false;
          return;
        }

        if (gwpItem && gwpItem.variant_id !== GWP_VARIANT_ID) {
          hadGwpItem = false;
          return removeGift(gwpItem.key, syncGift);
        }

        if (hadGwpItem && !gwpItem) {
          dismissed = true;
        }
        hadGwpItem = !!gwpItem;

        if (nonGwpItems.length > 0 && !gwpItem && !dismissed) {
          return addGift();
        }

        if (nonGwpItems.length === 0 && gwpItem) {
          hadGwpItem = false;
          return removeGift(gwpItem.key);
        }

        if (gwpItem && gwpItem.quantity !== 1) {
          return resetGiftQuantity(gwpItem.key);
        }

        processing = false;
      })
      .catch(function (err) {
        console.error('[GWP] sync error', err);
        processing = false;
      });
  }

  function onCartUpdate() { if (!processing) syncGift(); }
  function onCartAdd() {
    dismissed = false;
    syncGift();
  }

  window.addEventListener('shapes:cart:afteradditem', onCartAdd);
  window.addEventListener('shapes:cart:cartqtychange', syncGift);
  window.addEventListener('shapes:cart:update', onCartUpdate);

  document.addEventListener('DOMContentLoaded', syncGift);
})();
